// extracted by mini-css-extract-plugin
module.exports = {"confirm":"ConfirmModel_confirm__1C-Ru"};